import React, { Component } from 'react';

class Home extends Component {
  render() {
    return <h1 id="home_body">HOME</h1>;
  }
}

export default Home;
